import * as React from 'react'
import { NotificationListConnected } from './NotificationListConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const NotificationListExamples = () => {
  return (
    <div className="NotificationListExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <NotificationListConnected notificationGroup="messages" />
      </Provider>
    </div>
  )
}
